import swal from "sweetalert";
import axiosInstance from "../api";
import { setProductList, setSingleProduct } from "../../reusableSlice";
import {
  BarcodeFieldError,
  extractBarcodeServerMessage,
  mapBarcodeServerError,
} from "../../Components/Modules/Catalouge/Product/form/barcode";





export const getAllProductList = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/products`, { params: data });
      if (response?.data) {
        dispatch(setProductList(response?.data?.response.products))
        
      } else {
        dispatch(setProductList([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setProductList([]))
    }
  };

  // The dispatcher decides whether a single-create lands in the live catalog
  // or the staging table, and tells us which via `destination`. We use that to
  // pick the destination route ("live" → product list, "staged" → pending list)
  // and let the backend's message drive the toast copy either way.
  export const addProduct = (data, setLoading, navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("admin/products", data);
      if (response?.data?.status) {
        const result = response?.data?.response || {};
        const destination = result.destination === "staged" ? "staged" : "live";
        const message =
          result.message ||
          (destination === "staged"
            ? "Sent for manager review."
            : "Product created successfully.");
        swal({
          text: message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate(destination === "staged" ? "/product/pending" : "/product");
        return response;
      }
      const rawMessage = response?.data?.message || "Failed to create product";
      const barcodeMessage = mapBarcodeServerError(rawMessage);
      if (barcodeMessage) throw new BarcodeFieldError(barcodeMessage);
      swal({
        text: rawMessage,
        icon: "error",
        button: "Close",
      });
      return response;
    } catch (err) {
      if (err instanceof BarcodeFieldError) throw err;
      const barcodeMessage = extractBarcodeServerMessage(err);
      if (barcodeMessage) throw new BarcodeFieldError(barcodeMessage);
      console.error("addProduct failed:", err);
      swal({
        text:
          err?.response?.data?.message ||
          err?.message ||
          "Unable to create product. Please try again.",
        icon: "error",
        button: "Close",
      });
      throw err;
    } finally {
      setLoading(false);
    }
  };

  export const getSingleProduct = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/products/${id}`);
      
      if (response?.data) {
        dispatch(setSingleProduct(response?.data?.response))
      } else {
        dispatch(setSingleProduct([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setSingleProduct([]))
    }
  };

  export const updateProduct = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put("admin/products", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/product")
        return response;
      }
      const rawMessage = response?.data?.message || "Failed to update product";
      const barcodeMessage = mapBarcodeServerError(rawMessage);
      if (barcodeMessage) throw new BarcodeFieldError(barcodeMessage);
      swal({
        text: rawMessage,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
      return response;
    } catch (err) {
      if (err instanceof BarcodeFieldError) throw err;
      const barcodeMessage = extractBarcodeServerMessage(err);
      if (barcodeMessage) throw new BarcodeFieldError(barcodeMessage);
      console.error("updateProduct failed:", err);
      swal({
        text:
          err?.response?.data?.message ||
          err?.message ||
          "Unable to update product. Please try again.",
        icon: "error",
        button: "Close",
      });
      throw err;
    } finally {
      setLoading(false);
    }
  };


  export const deleteOneProduct = (id) => async (dispatch) => {
    // setLoading(true);
    try {
      const response = await axiosInstance.delete(`admin/products/${id}`);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        window.location.reload()
        // navigate("/membership")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {

    } finally {

    }
  };

  // Super-admin-only catalog wipe. The backend requires the exact confirm
  // phrase in the body and enforces the privilege check itself (403 otherwise);
  // we surface its message and let the caller refetch on success.
  export const deleteAllProducts = () => async () => {
    try {
      const response = await axiosInstance.post("admin/products/delete-all", {
        confirm: "DELETE ALL PRODUCTS",
      });
      const deleted = response?.data?.deleted;
      swal({
        text:
          response?.data?.message ||
          (typeof deleted === "number"
            ? `Soft-deleted ${deleted} product(s)`
            : "All products deleted"),
        icon: "success",
        button: "Close",
        timer: 2000,
      });
      return { ok: true, deleted };
    } catch (err) {
      const status = err?.response?.status;
      swal({
        text:
          status === 403
            ? "Super admin privilege required."
            : err?.response?.data?.message || "Failed to delete all products.",
        icon: "error",
        button: "Close",
      });
      return { ok: false };
    }
  };